/*
 * TourStock navigation behaviour.
 *  - Desktop (1024px and up): hover-intent mega panels, click/tap/keyboard
 *    disclosure, a "More" overflow item when the bar runs out of room.
 *  - Mobile and tablet: drill-down inside Empire's slide-in drawer.
 * Markup: snippets/ts-nav.liquid, snippets/ts-mobile-nav.liquid.
 */
(function () {
  'use strict';

  var DESKTOP = window.matchMedia('(min-width: 1024px)');
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');


  /*
   * Navigation analytics. One GA4 event, nav_click, for every link used in
   * the bar, the panels, the More panel and the mobile menu, plus nav_open
   * when a panel or drill-down is opened on purpose (click, tap or key,
   * never a hover). Nothing is sent without Shopify analytics consent, and
   * only the menu text and the destination path are recorded.
   */
  var GA4 = 'G-CT6V623E05';

  function analyticsAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return false;
    try {
      return privacy.analyticsProcessingAllowed();
    } catch (error) {
      return false;
    }
  }

  function track(name, params) {
    var reason = typeof window.gtag !== 'function' ? 'no-gtag' : !analyticsAllowed() ? 'no-consent' : '';
    debugLog(name, params, reason || 'sent');
    if (reason) return;
    var pageType = (document.querySelector('[data-ts-nav]') || {}).getAttribute
      ? document.querySelector('[data-ts-nav]').getAttribute('data-page-type')
      : '';
    window.gtag('event', name, Object.assign({
      send_to: GA4,
      page_type: pageType || undefined,
      transport_type: 'beacon'
    }, params));
  }

  /*
   * Tracking self-check for phones and other browsers without a console.
   * Open any page with ?ts_debug=1 (it stays on for the tab) to see consent,
   * whether Google's tag is present, and the last menu events with whether
   * each was sent or why not. Changes nothing for other visitors.
   */
  var DEBUG_KEY = 'ts-nav-debug';
  var DEBUG_LOG_KEY = 'ts-nav-debug-log';

  function debugOn() {
    try {
      if (/[?&]ts_debug=1(&|$)/.test(window.location.search)) window.sessionStorage.setItem(DEBUG_KEY, '1');
      return window.sessionStorage.getItem(DEBUG_KEY) === '1';
    } catch (error) {
      return false;
    }
  }

  function debugLog(name, params, result) {
    if (!debugOn()) return;
    try {
      var list = JSON.parse(window.sessionStorage.getItem(DEBUG_LOG_KEY) || '[]');
      list.push([name, (params && (params.nav_surface + '/' + (params.nav_section || '') + '/' + (params.nav_level || ''))) || '', result]);
      window.sessionStorage.setItem(DEBUG_LOG_KEY, JSON.stringify(list.slice(-8)));
    } catch (error) {}
  }

  function debugPanel() {
    if (!debugOn()) return;
    var box = document.createElement('pre');
    box.style.cssText = 'position:fixed;left:0;right:0;top:34px;z-index:2147483647;margin:0;padding:8px;max-height:60vh;overflow:auto;background:#111;color:#9f9;font:11px/1.35 monospace;white-space:pre-wrap;pointer-events:none;display:none';
    var pill = document.createElement('button');
    pill.type = 'button';
    pill.textContent = 'ts_debug: show';
    pill.style.cssText = 'position:fixed;right:4px;top:4px;z-index:2147483647;padding:6px 10px;background:#111;color:#9f9;border:1px solid #9f9;font:12px monospace;border-radius:4px';
    pill.addEventListener('click', function () {
      var open = box.style.display === 'none';
      box.style.display = open ? 'block' : 'none';
      pill.textContent = open ? 'ts_debug: hide' : 'ts_debug: show';
    });
    document.body.appendChild(box);
    document.body.appendChild(pill);
    var reach = {};
    [
      ['analytics.google.com', 'https://analytics.google.com/g/collect?ts_probe=1'],
      ['google.com', 'https://www.google.com/g/collect?ts_probe=1'],
      ['google-analytics.com', 'https://region1.google-analytics.com/g/collect?ts_probe=1'],
      ['googletagmanager.com', 'https://www.googletagmanager.com/gtag/js?ts_probe=1']
    ].forEach(function (probe) {
      reach[probe[0]] = '...';
      window.fetch(probe[1], { mode: 'no-cors' }).then(
        function () { reach[probe[0]] = 'reachable'; },
        function () { reach[probe[0]] = 'BLOCKED'; }
      );
    });
    function hits() {
      try {
        return window.performance.getEntriesByType('resource').filter(function (entry) {
          return /\/g\/collect|\/gtag\/js/.test(entry.name) && entry.name.indexOf('ts_probe=1') === -1;
        }).map(function (entry) {
          return entry.name.replace(/^https:\/\//, '').split('?')[0] + ' ' + (entry.responseStatus === undefined ? '' : entry.responseStatus) + ' ' + Math.round(entry.duration) + 'ms';
        });
      } catch (error) {
        return [];
      }
    }
    function render() {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      var consent = '';
      var region = '';
      var allowed = '';
      try { consent = JSON.stringify(privacy.currentVisitorConsent()); } catch (error) { consent = 'n/a'; }
      try { region = privacy.getRegion(); } catch (error) { region = 'n/a'; }
      try { allowed = String(privacy.analyticsProcessingAllowed()); } catch (error) { allowed = 'n/a'; }
      var list = [];
      try { list = JSON.parse(window.sessionStorage.getItem(DEBUG_LOG_KEY) || '[]'); } catch (error) {}
      box.textContent = [
        'ts_debug  ' + window.location.pathname,
        'privacy api: ' + (privacy ? 'loaded' : 'missing') + '  region: ' + region,
        'consent: ' + consent,
        'analytics allowed: ' + allowed,
        'gtag: ' + typeof window.gtag + '  internal flag: ' + (window.TS_INTERNAL ? 'yes' : 'no'),
        'google reachability: ' + Object.keys(reach).map(function (key) { return key + '=' + reach[key]; }).join('  '),
        'tag requests seen: ' + hits().length,
        hits().slice(-4).map(function (row) { return '  ' + row; }).join('\n'),
        'menu events (newest last):'
      ].concat(list.length ? list.map(function (row) { return '  ' + row.join('  '); }) : ['  none yet']).join('\n');
    }
    render();
    window.setInterval(render, 1000);
  }

  function clean(text) {
    return (text || '').replace(/\u2192/g, '').replace(/\s+/g, ' ').trim().slice(0, 60);
  }

  function pathOf(href) {
    try {
      return new URL(href, window.location.origin).pathname.slice(0, 100);
    } catch (error) {
      return '';
    }
  }

  function describeDesktop(link) {
    var item = link.closest('[data-ts-item]');
    var top = item && item.querySelector(':scope > .ts-nav__link');
    var section = clean(top && top.textContent);
    var more = item && item.hasAttribute('data-ts-more');
    var level = 'link';
    if (link.classList.contains('ts-nav__link')) level = 'top';
    else if (link.classList.contains('ts-panel__heading')) level = 'heading';
    else if (link.classList.contains('ts-panel__all')) level = 'shop_all';
    else if (link.classList.contains('ts-panel__quote')) level = 'trade_quote';
    else if (link.classList.contains('ts-panel__browse')) level = 'browse_range';
    if (more) {
      var col = link.closest('.ts-panel__col');
      var colHead = col && col.querySelector('.ts-panel__heading');
      section = clean(colHead && colHead.textContent) || 'More';
    }
    return { nav_surface: 'desktop', nav_section: section, nav_level: level, in_more: more || undefined };
  }

  function describeDrawer(link) {
    var panel = link.closest('[data-ts-panel-m]');
    var section = '';
    var level = 'link';
    if (panel) {
      var title = panel.querySelector('.ts-drawer__panel-title');
      section = clean(title && title.textContent);
      if (link.classList.contains('ts-drawer__all')) level = 'shop_all';
      else if (link.classList.contains('ts-drawer__quote')) level = 'trade_quote';
      else if (link.classList.contains('ts-drawer__group-title')) level = 'heading';
      else if (link.closest('.ts-drawer__links--solo')) level = 'browse_range';
    } else if (link.classList.contains('ts-drawer__cta')) {
      section = 'Trade & Bulk';
      level = 'trade_cta';
    } else if (link.hasAttribute('data-ts-popular')) {
      section = 'Popular searches';
      level = 'popular_search';
    } else if (link.closest('.ts-drawer__utility')) {
      section = 'Menu links';
      level = 'utility';
    } else {
      section = clean(link.textContent);
      level = 'top';
    }
    return { nav_surface: 'mobile', nav_section: section, nav_level: level };
  }

  function initTracking() {
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('a[href]');
      if (!link) return;
      var data = null;
      if (link.closest('[data-ts-nav]') || link.closest('.ts-nav__cta')) {
        data = link.classList.contains('ts-nav__cta')
          ? { nav_surface: 'desktop', nav_section: 'Trade & Bulk', nav_level: 'trade_cta' }
          : describeDesktop(link);
      } else if (link.closest('[data-ts-drawer]')) {
        data = describeDrawer(link);
      }
      if (!data) return;
      var labelEl = link.querySelector('.ts-drawer__cta-label');
      data.nav_label = clean((labelEl || link).textContent) || undefined;
      data.nav_path = pathOf(link.getAttribute('href'));
      track('nav_click', data);
    }, true);

    var form = document.querySelector('.ts-drawer__search');
    if (form) {
      form.addEventListener('submit', function () {
        track('nav_click', { nav_surface: 'mobile', nav_section: 'Search', nav_level: 'search_submit' });
      });
    }
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function initDesktop(nav) {
    var wrapper = nav.closest('.site-navigation-wrapper') || nav.parentElement;
    var header = document.querySelector('[data-site-header]');
    var items = Array.prototype.slice.call(nav.querySelectorAll(':scope > [data-ts-item]'));
    var more = nav.querySelector('[data-ts-more]');
    var moreList = nav.querySelector('[data-ts-more-list]');
    var regular = items.filter(function (item) { return item !== more; });
    var openItem = null;
    var pinned = false;
    var openTimer = null;
    var closeTimer = null;
    var lastPointer = 'mouse';
    var moreWidth = 0;

    var scrim = document.createElement('div');
    scrim.className = 'ts-scrim';
    scrim.setAttribute('aria-hidden', 'true');
    (header || document.body).insertBefore(scrim, (header || document.body).firstChild);

    function parts(item) {
      return {
        toggle: item.querySelector('[data-ts-toggle]'),
        panel: item.querySelector('[data-ts-panel]')
      };
    }

    function open(item, options) {
      var p = parts(item);
      if (!p.panel || !DESKTOP.matches) return;
      window.clearTimeout(openTimer);
      window.clearTimeout(closeTimer);
      if (openItem && openItem !== item) close(openItem);
      p.panel.hidden = false;
      p.toggle.setAttribute('aria-expanded', 'true');
      item.classList.add('is-open');
      scrim.classList.add('is-visible');
      openItem = item;
      pinned = Boolean(options && options.pin);
      if (options && options.focusFirst) {
        var first = p.panel.querySelector('a');
        if (first) first.focus();
      }
    }

    function close(item, returnFocus) {
      item = item || openItem;
      if (!item) return;
      var p = parts(item);
      window.clearTimeout(openTimer);
      window.clearTimeout(closeTimer);
      if (p.panel) p.panel.hidden = true;
      if (p.toggle) {
        p.toggle.setAttribute('aria-expanded', 'false');
        if (returnFocus) p.toggle.focus();
      }
      item.classList.remove('is-open');
      if (openItem === item) {
        openItem = null;
        pinned = false;
        scrim.classList.remove('is-visible');
      }
    }

    function trackOpen(item) {
      var top = item.querySelector(':scope > .ts-nav__link');
      track('nav_open', {
        nav_surface: 'desktop',
        nav_section: clean(top && top.textContent),
        in_more: item.hasAttribute('data-ts-more') || undefined
      });
    }

    function scheduleOpen(item) {
      window.clearTimeout(closeTimer);
      window.clearTimeout(openTimer);
      if (openItem === item) return;
      var delay = openItem ? 0 : 90;
      openTimer = window.setTimeout(function () { open(item); }, delay);
    }

    function scheduleClose(item) {
      window.clearTimeout(openTimer);
      window.clearTimeout(closeTimer);
      if (pinned || openItem !== item) return;
      closeTimer = window.setTimeout(function () { close(item); }, 200);
    }

    items.forEach(function (item) {
      var p = parts(item);
      if (!p.toggle) return;
      var link = item.querySelector(':scope > .ts-nav__link');
      var isButtonLink = link && link.tagName === 'BUTTON';

      item.addEventListener('pointerenter', function (event) {
        lastPointer = event.pointerType || 'mouse';
        if (event.pointerType === 'mouse') scheduleOpen(item);
      });

      item.addEventListener('pointerleave', function (event) {
        if (event.pointerType === 'mouse') scheduleClose(item);
      });

      item.addEventListener('pointerdown', function (event) {
        lastPointer = event.pointerType || 'mouse';
      });

      p.toggle.addEventListener('click', function (event) {
        event.preventDefault();
        if (openItem === item && pinned) {
          close(item);
        } else {
          open(item, { pin: true });
          trackOpen(item);
        }
      });

      if (link && !isButtonLink) {
        link.addEventListener('click', function (event) {
          if (lastPointer === 'touch' && openItem !== item) {
            event.preventDefault();
            open(item, { pin: true });
            trackOpen(item);
          }
        });
      }

      item.addEventListener('keydown', function (event) {
        var target = event.target;
        if (event.key === 'Escape' && openItem === item) {
          event.preventDefault();
          event.stopPropagation();
          close(item, true);
        } else if (event.key === 'ArrowDown' && (target === link || target === p.toggle)) {
          event.preventDefault();
          open(item, { pin: true, focusFirst: true });
          trackOpen(item);
        }
      });

      item.addEventListener('focusout', function (event) {
        if (!openItem || openItem !== item) return;
        var next = event.relatedTarget;
        if (next && !item.contains(next)) close(item);
      });
    });

    scrim.addEventListener('click', function () { close(); });
    document.addEventListener('click', function (event) {
      if (openItem && !openItem.contains(event.target)) close();
    });
    window.addEventListener('scroll', function () {
      if (openItem && window.pageYOffset > 8) close();
    }, { passive: true });

    function closeAndLayout() {
      close();
      layout();
    }

    function textOf(node) {
      return (node.textContent || '').replace(/\s+/g, ' ').trim();
    }

    function fillMore(overflowItems) {
      moreList.textContent = '';
      overflowItems.forEach(function (item) {
        var link = item.querySelector(':scope > .ts-nav__link');
        var col = document.createElement('div');
        col.className = 'ts-panel__col';
        var heading = document.createElement('a');
        heading.className = 'ts-panel__heading';
        heading.href = link.getAttribute('href');
        heading.textContent = textOf(link);
        col.appendChild(heading);

        var sources = Array.prototype.filter.call(
          item.querySelectorAll('.ts-panel__heading, .ts-panel__flat a'),
          function (src) { return !src.closest('[data-ts-stock-hidden]'); }
        );
        if (sources.length) {
          var ul = document.createElement('ul');
          var max = 8;
          Array.prototype.slice.call(sources, 0, max).forEach(function (src) {
            var li = document.createElement('li');
            var a = document.createElement('a');
            a.href = src.getAttribute('href');
            a.textContent = textOf(src);
            li.appendChild(a);
            ul.appendChild(li);
          });
          if (sources.length > max) {
            var li = document.createElement('li');
            var a = document.createElement('a');
            a.href = link.getAttribute('href');
            a.textContent = 'See all \u2192';
            li.appendChild(a);
            ul.appendChild(li);
          }
          col.appendChild(ul);
        }
        moreList.appendChild(col);
      });
      moreList.style.setProperty('--ts-cols', 4);
    }

    function layout() {
      if (!DESKTOP.matches) return;
      var wasOpen = openItem;
      if (wasOpen) close(wasOpen);

      regular.forEach(function (item) { item.classList.remove('is-overflow'); });
      if (more) more.hidden = true;

      var available = nav.clientWidth;
      var widths = regular.map(function (item) { return item.getBoundingClientRect().width; });
      var total = widths.reduce(function (sum, w) { return sum + w; }, 0);

      if (total <= available + 0.5 || !more) {
        nav.setAttribute('data-ts-ready', '');
        return;
      }

      more.hidden = false;
      moreWidth = more.getBoundingClientRect().width || moreWidth || 90;

      var used = 0;
      var overflow = [];
      regular.forEach(function (item, index) {
        if (overflow.length === 0 && used + widths[index] + moreWidth <= available + 0.5) {
          used += widths[index];
        } else {
          overflow.push(item);
        }
      });

      overflow.forEach(function (item) { item.classList.add('is-overflow'); });
      if (overflow.length) {
        fillMore(overflow);
      } else {
        more.hidden = true;
      }
      nav.setAttribute('data-ts-ready', '');
    }

    layout();
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(layout);
    }
    window.addEventListener('load', layout);
    document.addEventListener('ts:stock', layout);

    var lastWidth = nav.parentElement.clientWidth;
    if (window.ResizeObserver) {
      new ResizeObserver(function () {
        var w = nav.parentElement.clientWidth;
        if (w !== lastWidth) {
          lastWidth = w;
          layout();
        }
      }).observe(nav.parentElement);
    } else {
      window.addEventListener('resize', closeAndLayout);
    }

    DESKTOP.addEventListener
      ? DESKTOP.addEventListener('change', function () { close(); layout(); })
      : DESKTOP.addListener(function () { close(); layout(); });
  }

  function initDrawer(drawer) {
    var root = drawer.querySelector('[data-ts-root]');
    var panels = Array.prototype.slice.call(drawer.querySelectorAll('[data-ts-panel-m]'));
    var mobileNav = drawer.closest('[data-mobile-nav]');
    var current = null;
    var opener = null;

    function show(panel, trigger) {
      current = panel;
      opener = trigger;
      panel.inert = false;
      panel.scrollTop = 0;
      drawer.classList.add('is-drilled');
      root.inert = true;
      window.requestAnimationFrame(function () {
        panel.classList.add('is-open');
      });
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      var delay = REDUCED.matches ? 0 : 200;
      window.setTimeout(function () {
        var title = panel.querySelector('.ts-drawer__panel-title');
        if (title && current === panel) title.focus({ preventScroll: true });
      }, delay);
    }

    function hide(immediate) {
      if (!current) return;
      var panel = current;
      var trigger = opener;
      current = null;
      opener = null;
      if (immediate) drawer.classList.add('is-reset');
      panel.classList.remove('is-open');
      panel.inert = true;
      drawer.classList.remove('is-drilled');
      root.inert = false;
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
        if (!immediate) trigger.focus({ preventScroll: true });
      }
      if (immediate) {
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () { drawer.classList.remove('is-reset'); });
        });
      }
    }

    drawer.addEventListener('click', function (event) {
      var drill = event.target.closest('[data-ts-drill]');
      if (drill) {
        var panel = document.getElementById(drill.getAttribute('data-ts-drill'));
        if (panel) {
          show(panel, drill);
          var rowLabel = drill.querySelector('span');
          track('nav_open', { nav_surface: 'mobile', nav_section: clean(rowLabel && rowLabel.textContent) });
        }
        return;
      }
      if (event.target.closest('[data-ts-back]')) hide(false);
    });

    if (mobileNav && window.MutationObserver) {
      new MutationObserver(function () {
        if (mobileNav.dataset.open === 'false') {
          window.setTimeout(function () { hide(true); }, 400);
        }
      }).observe(mobileNav, { attributes: true, attributeFilter: ['data-open'] });
    }

    panels.forEach(function (panel) { panel.inert = true; });
  }

  ready(function () {
    var nav = document.querySelector('[data-ts-nav]');
    if (nav) initDesktop(nav);
    var drawer = document.querySelector('[data-ts-drawer]');
    if (drawer) initDrawer(drawer);
    initTracking();
    debugPanel();
  });
})();
